"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentInstanceModel = void 0;
var queryString_1 = require("../helpers/queryString");
var DocumentInstanceModel = /** @class */ (function () {
    function DocumentInstanceModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            DOCUMENTS: "".concat(APPURL, "/api/v1/documents"),
            GENERATE: "".concat(APPURL, "/api/v1/documents/generate"),
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    DocumentInstanceModel.prototype.extract = function (result) {
        return result.data;
    };
    DocumentInstanceModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    // Generate document from template
    DocumentInstanceModel.prototype.generateDocument = function (data) {
        return this.$http
            .post(this.URLS.GENERATE, data)
            .then(this.cacheResults);
    };
    // List documents
    DocumentInstanceModel.prototype.getDocuments = function (params) {
        var url = params
            ? "".concat(this.URLS.DOCUMENTS, "?").concat((0, queryString_1.toQueryString)(params))
            : this.URLS.DOCUMENTS;
        return this.$http.get(url).then(this.cacheResults);
    };
    // Get single document
    DocumentInstanceModel.prototype.getDocument = function (id) {
        return this.$http
            .get("".concat(this.URLS.DOCUMENTS, "/").concat(id))
            .then(this.cacheResults);
    };
    // Get user's documents
    DocumentInstanceModel.prototype.getUserDocuments = function (userId, params) {
        var url = params
            ? "".concat(this.URLS.DOCUMENTS, "/users/").concat(userId, "/documents?").concat((0, queryString_1.toQueryString)(params))
            : "".concat(this.URLS.DOCUMENTS, "/users/").concat(userId, "/documents");
        return this.$http.get(url).then(this.cacheResults);
    };
    // Update field value
    DocumentInstanceModel.prototype.updateDocumentField = function (documentId, fieldName, data) {
        return this.$http
            .put("".concat(this.URLS.DOCUMENTS, "/").concat(documentId, "/fields/").concat(fieldName), data)
            .then(this.cacheResults);
    };
    // Submit completed document
    DocumentInstanceModel.prototype.submitDocument = function (id, data) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/submit"), data || {})
            .then(this.cacheResults);
    };
    // Archive document
    DocumentInstanceModel.prototype.archiveDocument = function (id) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/archive"), {})
            .then(this.cacheResults);
    };
    // Create invitation for external signing
    DocumentInstanceModel.prototype.createInvitation = function (documentId, data) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(documentId, "/invitations"), data)
            .then(this.cacheResults);
    };
    // Send reminder
    DocumentInstanceModel.prototype.sendReminder = function (id, data) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/remind"), data)
            .then(this.cacheResults);
    };
    // Utility methods
    DocumentInstanceModel.prototype.getUserAssignment = function (document, userId) {
        return document.assigned_users.find(function (a) { return a.user_id === userId; });
    };
    DocumentInstanceModel.prototype.getUserFields = function (document, userId) {
        var _a;
        var assignment = this.getUserAssignment(document, userId);
        if (!assignment) {
            return [];
        }
        return (((_a = document.document_fields) === null || _a === void 0 ? void 0 : _a.filter(function (field) {
            return assignment.fields.includes(field.field_name);
        })) || []);
    };
    DocumentInstanceModel.prototype.calculateUserCompletion = function (document, userId) {
        var userFields = this.getUserFields(document, userId);
        if (!userFields.length) {
            return 0;
        }
        var completedFields = userFields.filter(function (field) {
            return field.value !== undefined && field.value !== null && field.value !== "";
        });
        return Math.round((completedFields.length / userFields.length) * 100);
    };
    DocumentInstanceModel.prototype.getSignatureFields = function (document) {
        var _a;
        return (((_a = document.document_fields) === null || _a === void 0 ? void 0 : _a.filter(function (field) { return field.field_type === "signature"; })) || []);
    };
    DocumentInstanceModel.prototype.getPendingSignatures = function (document, userId) {
        var signatureFields = this.getSignatureFields(document);
        // Filter by user if specified
        if (userId) {
            var userAssignment_1 = this.getUserAssignment(document, userId);
            if (userAssignment_1) {
                signatureFields = signatureFields.filter(function (field) {
                    return userAssignment_1.fields.includes(field.field_name);
                });
            }
        }
        // Return only unsigned fields
        return signatureFields.filter(function (field) { return !field.value || field.value === ""; });
    };
    DocumentInstanceModel.prototype.canUserSignField = function (document, userId, fieldName) {
        var assignment = this.getUserAssignment(document, userId);
        return assignment ? assignment.fields.includes(fieldName) : false;
    };
    DocumentInstanceModel.prototype.isDocumentFullySigned = function (document) {
        var signatureFields = this.getSignatureFields(document);
        return signatureFields.every(function (field) { return field.value && field.value !== ""; });
    };
    DocumentInstanceModel.prototype.getCompletionByRole = function (document) {
        var result = {};
        if (!document.assigned_users) {
            return result;
        }
        document.assigned_users.forEach(function (assignment) {
            var _a;
            var userFields = ((_a = document.document_fields) === null || _a === void 0 ? void 0 : _a.filter(function (field) {
                return assignment.fields.includes(field.field_name);
            })) || [];
            var completedFields = userFields.filter(function (field) {
                return field.value !== undefined &&
                    field.value !== null &&
                    field.value !== "";
            });
            result[assignment.role] = userFields.length
                ? Math.round((completedFields.length / userFields.length) * 100)
                : 0;
        });
        return result;
    };
    DocumentInstanceModel.prototype.validateFieldAssignments = function (assignments) {
        var errors = [];
        var assignedFields = new Set();
        assignments.forEach(function (assignment) {
            if (!assignment.user_id) {
                errors.push("Assignment missing user_id");
            }
            if (!assignment.role) {
                errors.push("Assignment for user ".concat(assignment.user_id, " missing role"));
            }
            if (!assignment.fields || assignment.fields.length === 0) {
                errors.push("Assignment for user ".concat(assignment.user_id, " has no fields"));
            }
            // Check for duplicate field assignments
            assignment.fields.forEach(function (field) {
                if (assignedFields.has(field)) {
                    errors.push("Field ".concat(field, " is assigned to multiple users"));
                }
                assignedFields.add(field);
            });
        });
        return {
            valid: errors.length === 0,
            errors: errors,
        };
    };
    return DocumentInstanceModel;
}());
exports.DocumentInstanceModel = DocumentInstanceModel;
DocumentInstanceModel.$inject = ["$http", "APPURL"];
exports.default = DocumentInstanceModel;
